// extracted by mini-css-extract-plugin
export var bold = "_ra-0";